import React from "react";
import NotFound from "../pages/NotFound";
import AuthLayout from "../components/layout/AuthLayout";
import DashboardLayout from "../components/layout/DashboardLayout";
import Home from "../pages/dashboard/Dashboard";
import Customers from "../pages/customers/Customers";
import HostingPlans from "../pages/hosting-plan/HostingPlan";
import PaymentHistory from "../pages/payment/Payment";
import ThemePage from "../pages/themes/Themes";
import UpdatePassword from "../pages/update-password/UpdatePassword";
import CustomerQueries from "../pages/customer-queries/CustomerQueries";
const Signin = React.lazy(() => import("../pages/auth/signin/Signin"));



// const Home = React.lazy(() => import("../pages/landing-page/Home"));
// const Login = React.lazy(() => import("../pages/auth/signin/Signin"));
// const Signup = React.lazy(() => import("../pages/auth/signup/Signup"));

// routes/RouteConfig.js
const routeConfig = [
  {
    path: "/",
    title: "Home",
    component: Home,
    exact: true,
    private: true,
    layout: DashboardLayout,
  },
  {
    path: "/dashboard",
    title: "Home",
    component: Home,
    exact: true,
    private: true,
    layout: DashboardLayout,
  },
  {
    path: "/customers",
    title: "Customer",
    component: Customers,
    exact: true,
    private: true,
    layout: DashboardLayout,
  },
  {
    path: "/customer-queries",
    title: "Customer Queries",
    component: CustomerQueries,
    exact: true,
    private: true,
    layout: DashboardLayout,
  },
  {
    path: "/plans",
    title: "hosting Plans",
    component: HostingPlans,
    exact: true,
    private: true,
    layout: DashboardLayout,
  },
  {
    path: "/payment",
    title: "Payment History",
    component: PaymentHistory,
    exact: true,
    private: true,
    layout: DashboardLayout,
  },
  {
    path: "/theme",
    title: "Theme",
    component: ThemePage,
    exact: true,
    private: true,
    layout: DashboardLayout,
  },
  {
    path: "/signin",
    title: "Account Signin",
    component: Signin,
    layout: AuthLayout,
    private: false,
  },
  {
    path: "/update-password",
    title: "Update Password",
    component: UpdatePassword,
    layout: DashboardLayout,
    private: false,
  },

  { path: "*", title: "", component: NotFound, layout: null }, // Catch-all route
];

export default routeConfig;
